module.exports = __webpack_public_path__ + "static/media/img3.c45360d4.jpg";